import { render, staticRenderFns } from "./bank-card.vue?vue&type=template&id=06c3e404&scoped=true&"
import script from "./bank-card.vue?vue&type=script&lang=js&"
export * from "./bank-card.vue?vue&type=script&lang=js&"
import style0 from "./bank-card.vue?vue&type=style&index=0&id=06c3e404&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c3e404",
  null
  
)

export default component.exports